export const ROLES = {
  // Warehouse Management System
  WMS_ADMIN: 'WMS_Admin',
  WMS_MANAGER: 'WMS_Manager',
  WMS_SUPER: 'WMS_Super',
  WMS_USER: 'WMS_User',

  // Production Management System
  PPMS_ADMIN: 'PPMS_Admin',
  PPMS_MANAGER: 'PPMS_Manager',
  PPMS_SUPER: 'PPMS_Super',
  PPMS_USER: 'PPMS_User',

  // Quality Management System
  QMS_ADMIN: 'QMS_Admin',
  QMS_MANAGER: 'QMS_Manager',
  QMS_SUPER: 'QMS_Super',
  QMS_USER: 'QMS_User',

  // Asset Management System
  AMS_ADMIN: 'AMS_Admin',
  AMS_MANAGER: 'AMS_Manager',
  AMS_SUPER: 'AMS_Super',
  AMS_USER: 'AMS_User',

  // Mold Management System
  MMS_ADMIN: 'MMS_Admin',
  MMS_MANAGER: 'MMS_Manager',
  MMS_SUPER: 'MMS_Super',
  MMS_USER: 'MMS_User',

  // Customer Dashboard
  CCAMS_CUS: 'CCAMS_Cus',
  CCAMS_LOGI: 'CCAMS_Logi',

  // App Admin
  APP_ADMIN: 'APP_Admin',
  APP_SUPER_ADMIN: 'APP_Super_Admin',
};

export const MODULES = {
  WMS: 'Warehouse Management System',
  PPMS: 'Production Management System',
  QMS: 'Quality Management System',
  AMS: 'Asset Management System',
  MMS: 'Mold Management System',
  CUSTOMER_DASHBOARD: 'Customer Dashboard',
  ADMIN_DASHBOARD: 'Admin Dashboard',
  MASTERS: 'Masters',
  // SETTINGS: 'Settings',
};

// Map roles to the modules they can access
export const ROLE_MODULE_ACCESS = {
  // WMS Roles
  [ROLES.WMS_ADMIN]: [MODULES.WMS],
  [ROLES.WMS_MANAGER]: [MODULES.WMS],
  [ROLES.WMS_SUPER]: [MODULES.WMS],
  [ROLES.WMS_USER]: [MODULES.WMS],

  // PPMS Roles
  [ROLES.PPMS_ADMIN]: [MODULES.PPMS],
  [ROLES.PPMS_MANAGER]: [MODULES.PPMS],
  [ROLES.PPMS_SUPER]: [MODULES.PPMS],
  [ROLES.PPMS_USER]: [MODULES.PPMS],

  // QMS Roles
  [ROLES.QMS_ADMIN]: [MODULES.QMS],
  [ROLES.QMS_MANAGER]: [MODULES.QMS],
  [ROLES.QMS_SUPER]: [MODULES.QMS],
  [ROLES.QMS_USER]: [MODULES.QMS],

  // AMS Roles
  [ROLES.AMS_ADMIN]: [MODULES.AMS],
  [ROLES.AMS_MANAGER]: [MODULES.AMS],
  [ROLES.AMS_SUPER]: [MODULES.AMS],
  [ROLES.AMS_USER]: [MODULES.AMS],

  // MMS Roles
  [ROLES.MMS_ADMIN]: [MODULES.MMS],
  [ROLES.MMS_MANAGER]: [MODULES.MMS],
  [ROLES.MMS_SUPER]: [MODULES.MMS],
  [ROLES.MMS_USER]: [MODULES.MMS],

  // Customer Roles
  [ROLES.CCAMS_CUS]: [MODULES.CUSTOMER_DASHBOARD],
  [ROLES.CCAMS_LOGI]: [MODULES.CUSTOMER_DASHBOARD],

  // App Admin Roles
  [ROLES.APP_ADMIN]: [
    MODULES.WMS,
    MODULES.PPMS,
    MODULES.QMS,
    MODULES.AMS,
    MODULES.MMS,
    MODULES.CUSTOMER_DASHBOARD,
    MODULES.MASTERS,
    MODULES.ADMIN_DASHBOARD,
  ],
  [ROLES.APP_SUPER_ADMIN]: [
    MODULES.WMS,
    MODULES.PPMS,
    MODULES.QMS,
    MODULES.AMS,
    MODULES.MMS,
    MODULES.CUSTOMER_DASHBOARD,
    MODULES.MASTERS,
    // MODULES.SETTINGS,
    MODULES.ADMIN_DASHBOARD,
  ],
};

export const PERMISSIONS = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
};

// Map roles to their specific permissions (CRUD)
export const ROLE_PERMISSIONS = {
  // WMS Roles
  [ROLES.WMS_ADMIN]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE, PERMISSIONS.DELETE],
  [ROLES.WMS_MANAGER]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.WMS_SUPER]: [PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.WMS_USER]: [PERMISSIONS.READ],

  // PPMS Roles
  [ROLES.PPMS_ADMIN]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE, PERMISSIONS.DELETE],
  [ROLES.PPMS_MANAGER]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.PPMS_SUPER]: [PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.PPMS_USER]: [PERMISSIONS.READ],

  // QMS Roles
  [ROLES.QMS_ADMIN]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE, PERMISSIONS.DELETE],
  [ROLES.QMS_MANAGER]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.QMS_SUPER]: [PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.QMS_USER]: [PERMISSIONS.READ],

  // AMS Roles
  [ROLES.AMS_ADMIN]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE, PERMISSIONS.DELETE],
  [ROLES.AMS_MANAGER]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.AMS_SUPER]: [PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.AMS_USER]: [PERMISSIONS.READ],

  // MMS Roles
  [ROLES.MMS_ADMIN]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE, PERMISSIONS.DELETE],
  [ROLES.MMS_MANAGER]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.MMS_SUPER]: [PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.MMS_USER]: [PERMISSIONS.READ],

  // Customer Roles
  [ROLES.CCAMS_CUS]: [PERMISSIONS.READ, PERMISSIONS.UPDATE],
  [ROLES.CCAMS_LOGI]: [PERMISSIONS.READ, PERMISSIONS.UPDATE],

  // App Admin Roles
  [ROLES.APP_ADMIN]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE, PERMISSIONS.DELETE],
  [ROLES.APP_SUPER_ADMIN]: [PERMISSIONS.CREATE, PERMISSIONS.READ, PERMISSIONS.UPDATE, PERMISSIONS.DELETE],
};

/**
 * Get the list of allowed modules for a given set of user roles.
 * @param {string[]} userRoles - Array of roles the user has.
 * @returns {string[]} - Array of unique module names the user can access.
 */
export const getAllowedModules = (userRoles) => {
  if (!userRoles || !Array.isArray(userRoles)) {
    return [];
  }

  const isExternalCustomer = localStorage.getItem('IsExternalCustomer') === 'true';
  if (isExternalCustomer) {
    return [MODULES.CUSTOMER_DASHBOARD];
  }

  const allowedModules = new Set();

  userRoles.forEach((role) => {
    const modules = ROLE_MODULE_ACCESS[role];
    if (modules) {
      modules.forEach((module) => allowedModules.add(module));
    }
  });

  return Array.from(allowedModules);
};

/**
 * Check if a user has access to a specific module.
 * @param {string} moduleName - The name of the module to check.
 * @param {string[]} userRoles - Array of roles the user has.
 * @returns {boolean} - True if the user has access, false otherwise.
 */
export const hasModuleAccess = (moduleName, userRoles) => {
  const allowedModules = getAllowedModules(userRoles);
  return allowedModules.includes(moduleName);
};

/**
 * Notification Admin Portal access (events config, etc.).
 * APP_Admin / APP_Super_Admin only — module users use the inbox.
 */
export const isNotificationAdmin = (userRoles) => {
  if (!userRoles || !Array.isArray(userRoles)) return false;
  return userRoles.includes(ROLES.APP_ADMIN) || userRoles.includes(ROLES.APP_SUPER_ADMIN);
};

/**
 * Reads roles from MSAL id token claims in session (same source as ProtectedRoute).
 */
export const getCurrentUserRoles = () => {
  try {
    const raw = sessionStorage.getItem('MSAL_LAST_IDTOKEN_CLAIMS');
    if (raw) {
      const claims = JSON.parse(raw);
      return Array.isArray(claims?.roles) ? claims.roles : [];
    }
  } catch (_err) {
    // ignore
  }
  return [];
};

// Map routes to modules for access control
export const ROUTE_MODULE_MAP = {
  // WMS Routes
  '/warehouse': MODULES.WMS,
  '/shipment-tile': MODULES.WMS,
  '/pos': MODULES.WMS,
  '/mappings': MODULES.WMS,
  '/inventory-tile': MODULES.WMS,
  '/inventory-scanning': MODULES.WMS,


  // PPMS Routes
  '/production': MODULES.PPMS,
  '/plannerv2': MODULES.PPMS,
  '/planning-workspace': MODULES.PPMS,

  // QMS Routes
  '/inspectionplan-tile': MODULES.QMS,
  '/quality-approval': MODULES.QMS,
  '/inspection-results': MODULES.QMS,
  '/quality-alert-pages': MODULES.QMS,
  '/change-request': MODULES.QMS,

  // MMS Routes
  '/mold-receiving': MODULES.MMS,
  '/mold-maintenance': MODULES.MMS,
  '/mold-release': MODULES.MMS,
  '/future-actions': MODULES.MMS,

  // AMS Routes
  '/cell': MODULES.AMS,
  '/auxiliary-equipment': MODULES.AMS,
  '/forklift': MODULES.AMS,
  '/water-towers': MODULES.AMS,
  '/air-compressors': MODULES.AMS,
  '/plant': MODULES.AMS,
  '/robots': MODULES.AMS,
  '/overhead-crane': MODULES.AMS,

  // Customer Dashboard Routes
  '/sales-dashboard': MODULES.CUSTOMER_DASHBOARD,
  '/shipments': MODULES.CUSTOMER_DASHBOARD,

  // Admin Dashboard Routes
  '/admin-dashboard': MODULES.ADMIN_DASHBOARD,
  '/plannerdashboard': MODULES.ADMIN_DASHBOARD,
  '/plannerv2': MODULES.ADMIN_DASHBOARD,
  '/planning-workspace': MODULES.ADMIN_DASHBOARD,
  '/notifications/events': MODULES.ADMIN_DASHBOARD,

  // Masters Routes
  '/stock-transfer': MODULES.MASTERS,
  '/plan': MODULES.MASTERS,
  '/Mold': MODULES.MASTERS,
  // '/machine': MODULES.MASTERS,
  '/customer-master': MODULES.MASTERS,
  '/carrier-master': MODULES.MASTERS,
  '/vendor-master': MODULES.MASTERS,
  '/part-master': MODULES.MASTERS,
  '/location-master': MODULES.MASTERS,
  '/material': MODULES.MASTERS,

  // Settings Routes
  //'/users': MODULES.SETTINGS,
  //'/roles': MODULES.SETTINGS,
  //'/notifications': MODULES.SETTINGS,
  //'/logs': MODULES.SETTINGS,
};